<template>
  <div
    class="tets-box"
    ref="testBox"
    v-show="org_jp_status ? isShowView && jude_route && jude_jp_pay_status  : isShowView && jude_route"
  >
    <!-- 老师 -->
    <div id="interaction-wrap" ref="interactionBox" v-show="inser_show">
      <div
        class="interaction-name"
        @mousedown="down_copy($event)"
        @mousemove="move_copy($event)"
        @mouseup="end_copy($event)"
        @mouseleave="end_leave($event)"
        @touchstart.prevent="down_copy($event)"
        @touchmove.prevent="move_copy($event)"
        @touchend.prevent="end_copy($event)"
      >
        {{ msg }}
      </div>
      <div :class="interactionStyle">
        <span class="pic-index" v-if="pic_show" @click="openPic">投图</span>
        <span
          class="spotlight-index"
          v-if="spotlight_show"
          @click="openMagnifier('spotlight')"
          >聚光灯</span
        >
        <span class="score-index" v-if="score_show" @click="openScore"
          >计分器</span
        >
        <span class="voter-index" v-if="voter_show" @click="openVoter"
          >投票器</span
        >
        <span class="lamp-index" v-if="lamp_show" @click="openLamp"
          >信号灯</span
        >
        <span class="handwrite-index" @click="open_close_hand_write">白板</span>
        <span class="timer-index" v-if="timer_show" @click="timerFun"
          >计时器</span
        >
        <span
          class="throw-screen-item"
          v-show="throw_show && !isPc()"
          :class="{ 'pc-active': isPc() }"
          @click="throwShow"
        >
          <input
            v-if="input_status"
            type="file"
            name="file_head"
            id="file_head"
            multiple="multiple"
            accept="image/*"
            style="opacity: 0"
          />
          <!--{{isPc() ? '' : "投屏"}}-->
          投屏
        </span>
        <span class="call-index" v-if="call_show" @click="callShow">点名</span>
        <span
          class="lock-screen-index"
          :class="{ 'lock-screen-active': lock_switch }"
          v-if="lock_show"
          @click="lockScreen"
          >锁屏</span
        >
        <span class="lock-loading" v-if="lock_loading"></span>
      </div>
    </div>

    <!-- 学生 -->
    <div
      id="interaction-wrap"
      v-show="
        !inser_show &&
        (is_show_student_white_screen || voter_show) &&
        $route.name != 'login' &&
        $route.name != 'electronLogin' &&
        $route.name != 'publicLogin' &&
        $route.name != 'error' &&
        $route.name != 'wwxAuthSuccess'
      "
    >
      <div class="interaction-name" @click.stop="show_hide">{{ msg }}</div>
      <div
        class="interaction-type student-interaction-type"
        v-show="show_hide_stu"
      >
        <!-- :style="{ display: show_interaction_type ? 'block' : 'none' }"  显示互动功能-->
        <span class="white-screen" @click="whiteScreenOpen">白板分享</span>
        <!-- v-if="is_show_student_white_screen" 显示投票器 -->
        <span class="voter-index" v-if="voter_show" @click="openVoterStudent"
          >投票器</span
        >
      </div>
    </div>

    <throwingScreen
      @watchThrow="throwData"
      :data="throw_data"
      :item="throw_son_item"
    ></throwingScreen>

    <handWrite
      @closeHandWrite="closeHandWriteFunc"
      v-if="show_hand_write"
    ></handWrite>
    <lockScreen :data="lock_data"></lockScreen>
    <rollCall></rollCall>
    <timer :data="timer_data" @watchChild="parentReceive"></timer>
    <signalLamp></signalLamp>
    <voter></voter>
    <score></score>
    <throwingPic v-if="pic_enabled" @close="onPicClose"></throwingPic>
    <throwingPicPresentation
      v-if="isShowTeacherPic"
      :imgList="teacherPicImgList"
      @close="onTeacherPicClose"
      @change="onTeacherPicChange"
    >
    </throwingPicPresentation>
    <magnifier
      v-if="magnifier_enabled"
      :type="magnifier_type"
      @closeMagnifier="closeMagnifierFunc"
    ></magnifier>
  </div>
</template>

<script>
// import organization from "@/mixin/organization.js";
import handWrite from "@/components/interaction/handWrite/index";
import lockScreen from "@/components/interaction/lockScreen";
import rollCall from "@/components/interaction/rollCall";
import throwingScreen from "@/components/interaction/throwingScreen";
import signalLamp from "@/components/interaction/signalLamp";
import voter from "@/components/interaction/voter";
import score from "@/components/interaction/score";
import timer from "@/components/interaction/timer";
import throwingPic from "@/components/interaction/throwingPic/index";
import throwingPicPresentation from "@/components/interaction/throwingPic/presentation";
import magnifier from "@/components/interaction/magnifier/index";
import { logoutApi } from "@/api/commonApi";
import { jpGetUserInfo } from "@/api/jpApi";
import {
  getInteractiveStatus,
  getWsToken,
  teacherLockScreen,
  getTeacherLockScreen,
  getWsUserInfo,
  getStuBookScreen,
} from "./indexApi";
export default {
  name: "interaction",
  // mixins: [organization],
  data() {
    return {
      msg: "课堂互动",
      lock_switch: 0,
      websock: "",
      //是否显示课堂互动offsetLeft
      inser_show: false,
      //是否显示课堂互动-锁屏
      lock_show: false,
      //是否显示课堂互动-点名
      call_show: false,
      //是否显示课堂互动-随机点名
      radom_call_show: false,
      //是否显示课堂互动-投屏
      throw_show: false,
      //是否展示互动
      show_interaction_type: false,
      //是否打开白板
      show_hand_write: false,
      // 是否显示计时器
      timer_show: false,
      //是否展示投图
      pic_show: false,
      pic_enabled: false,
      //是否展示放大镜
      magnifier_show: false,
      magnifier_enabled: false,
      //是否展示聚光灯
      spotlight_show: false,
      //是否显示信号灯
      lamp_show: false,
      //是否显示投票器
      voter_show: false,
      //是否显示计分器
      score_show: false,
      //锁屏数据
      lock_data: null,
      //投屏数据
      throw_data: 0,
      //投屏返回数据
      throw_son_item: null,
      //投屏发送数据
      throw_data_serve: {
        fiel_cdn_id: "",
        url: "",
        pic_rotate: "",
      },
      //计时器打开
      timer_data: 0,
      //当前页面科目班级章节信息
      teacherCourseData: {
        subject_id: "",
        grad_id: "",
        section_id: "",
        course_id: "",
      },
      //检查websock定时
      ws_check_status: null,
      //投屏input状态
      input_status: false,
      ws_heartBeat: null,
      //token错误次数
      token_error_count: 0,
      //移动端拖拽横坐标开始位置
      //x:0,
      //移动端拖拽综坐标开始位置
      //y:0,
      body_width: 0,
      body_height: 0,
      //锁屏等待(api)
      lock_loading: false,
      //判断是否显示互动(根据页面路径)
      jude_route: true,
      isShowView: true,
      flag: false,
      cur: {
        x: 0,
        y: 0,
      },
      nx: 0,
      ny: 0,
      dx: 0,
      x: 0,
      y: 0,
      div2: null,
      move_obj: {
        //移动的偏移量
        left: "0.5rem",
        top: "0.5rem",
        off_left: 0,
        off_top: 0,
      },
      pointer_obj: {
        //移动的位置
        //轨迹点
        start_x: "",
        start_y: "",
        end_x: "",
        end_y: "",
      },
      start_time: "",
      end_time: "",
      jude_jp_pay_status: false,
      org_jp_status: localStorage.getItem("common_org_code") == "jp",
      is_show_student_white_screen: true,
      magnifier_type: "",
      is_two_rows: false,
      barItemCount: 0,
      isShowTeacherPic: false,
      teacherPicVersion: null,
      teacherPicImgList: [],
      show_hide_stu: false,
    };
  },
  components: {
    handWrite,
    lockScreen,
    rollCall,
    throwingScreen,
    timer,
    signalLamp,
    voter,
    throwingPic,
    throwingPicPresentation,
    score,
    magnifier,
  },
  computed: {
    listenstage() {
      return this.$store.state.interaction.class_id;
    },
    answersen() {
      return this.$store.state.interaction.answer_send;
    },
    lampsen() {
      return this.$store.state.interaction.lamp_send;
    },
    votersen() {
      return this.$store.state.interaction.voter_send;
    },
    votersenData() {
      return this.$store.state.interaction.voter_data;
    },
    scoresen() {
      return this.$store.state.interaction.score_send;
    },
    scoresenData() {
      return this.$store.state.interaction.score_data;
    },
    timerSend() {
      return this.$store.state.interaction.timer_data_event;
    },
    timerSendData() {
      return this.$store.state.interaction.timer_data;
    },
    downtimerSendData() {
      return this.$store.state.interaction.cutdown_data;
    },
    downtimerSend() {
      return this.$store.state.interaction.downtimer_data_event;
    },
    interactionStyle() {
      return {
        "interaction-type": true,
        show: this.show_interaction_type,
        "two-rows": this.is_two_rows,
      };
    },
  },
  methods: {
    // 学生课堂互动
    show_hide() {
      this.show_hide_stu = !this.show_hide_stu;
    },
    //计时器通知关闭事件
    parentReceive(message) {
      this.timer_data = message;
    },
    //投屏通知关闭事件
    throwData(message) {
      if (message.count) {
        this.throw_data_serve = message;
        this.sendPublic("event_projection_screen");
      } else {
        this.sendPublic("event_projection_screen_close");
        this.throw_data = message.count;
      }
    },
    //缺少参数时处理
    detailLackParam() {
      let flag = true;
      let arr = [
        this.$cookies.get("user_type"),
        this.$cookies.get("user_id"),
        this.$cookies.get("class_id"),
        this.$cookies.get("ws_token"),
        this.$cookies.get("http_ws_host"),
        this.$cookies.get("http_ws_socket_url"),
      ];
      for (let item of arr) {
        if (!item || item == "undefined") {
          flag = false;
        }
      }
      return flag;
    },
    //发送事件
    sendPublic(type) {
      if (!this.detailLackParam()) {
        //console.log("缺少参数。。。");
        // this.$message("服务更新中,请稍后再试");
        this.getUserInfo();
        return;
      }
      console.log(Boolean(localStorage.getItem("jp_is_valid")));
      if (
        !localStorage.getItem("jp_is_valid") &&
        localStorage.getItem("common_org_code") == "jp"
      ) {
        console.log("过期了阻止时间接受");
        return;
      }
      console.log(type);
      let publicSendEvent = {
        event_user_connection: {
          //用户连接互动服务事件
          user_type_id: this.$cookies.get("user_type"),
          user_id: this.$cookies.get("user_id"),
          class_id: this.$cookies.get("class_id"),
        },
        heartbeat: {
          //用户心跳事件
          class_id: this.$cookies.get("class_id"),
        },
        event_server_lock_screen: {
          //老师锁屏/解锁事件
          user_type_id: this.$cookies.get("user_type"),
          user_id: this.$cookies.get("user_id"),
          class_id: this.$cookies.get("class_id"),
          lock_screen_status: this.lock_switch ? 0 : 1,
          stu_book_lock_screen_status: this.$cookies.get(
            "stu_book_lock_screen_status"
          ),
        },
        event_answer_ready: {
          //服务端抢答准备事件
          teacher_id: this.$cookies.get("user_id"),
          class_id: this.$cookies.get("class_id"),
        },
        event_answer_start: {
          //服务端抢答开始
          teacher_id: this.$cookies.get("user_id"),
          class_id: this.$cookies.get("class_id"),
          start_time: new Date().getTime(),
          event_id: $cookies.get("event_id"),
        },
        event_answer_system_stop: {
          //服务端抢答系统关闭事件
          teacher_id: this.$cookies.get("user_id"),
          class_id: this.$cookies.get("class_id"),
          event_id: this.$cookies.get("event_id"),
        },
        event_random_answer: {
          //服务端随机点名事件
          class_id: this.$cookies.get("class_id"),
          event_id: this.$cookies.get("event_id"),
        },
        event_answer_student_sent: {
          //服务端学生抢答事件
          student_id: this.$cookies.get("user_id"),
          student_name: this.$cookies.get("user_name"),
          class_id: this.$cookies.get("class_id"),
          event_id: this.$cookies.get("event_id"),
        },
        event_projection_screen: {
          //服务端投屏事件
          teacher_id: this.$cookies.get("user_id"),
          fiel_cdn_id: this.throw_data_serve.file_cdn_id,
          url: this.throw_data_serve.file_cdn_url,
          pic_rotate: this.throw_data_serve.rotate,
          ws_multiple: this.throw_data_serve.ws_multiple,
          scroll_x: this.throw_data_serve.scroll_x,
          scroll_y: this.throw_data_serve.scroll_y,
          // init_width:this.throw_data_serve.init_width,
          // init_height:this.throw_data_serve.init_height,
        },
        event_projection_screen_close: {
          //服务端关闭投屏事件
          teacher_id: this.$cookies.get("user_id"),
        },
        event_traffic_light_click: {
          //点击交通灯
          class_id: this.$cookies.get("class_id"),
        },
        event_traffic_light_close: {
          //关闭交通灯
          class_id: this.$cookies.get("class_id"),
        },
        event_traffic_light_start: {
          //开启交通灯
          class_id: this.$cookies.get("class_id"),
        },
        event_traffic_light_stop: {
          //结束交通灯
          class_id: this.$cookies.get("class_id"),
        },
        event_traffic_light_vote: {
          //学生投票(信号灯)
          class_id: this.$cookies.get("class_id"),
          color: localStorage.getItem("lamp_student_choose_type"),
        },
        //老师点击投票器
        event_voter_click: {
          class_id: this.$cookies.get("class_id"),
        },
        //老师发布投票器
        event_voter_publish: this.votersenData,
        event_voter_close: {
          //老师关闭投票器
          class_id: this.$cookies.get("class_id"),
        },
        event_voter_stop: {
          //老师结束投票器
          class_id: this.$cookies.get("class_id"),
        },
        event_voter_create: {
          //老师创建投票
          class_id: this.$cookies.get("class_id"),
        },
        event_voter_vote: {
          class_id: this.$cookies.get("class_id"),
          options: this.votersenData,
        },
        event_indicator_open: {
          //老师点击计分器
          class_id: this.$cookies.get("class_id"),
          subject_id: sessionStorage.getItem("root_subject"),
        },
        event_indicator_close: {
          //老师关闭计分器
          class_id: this.$cookies.get("class_id"),
        },
        //计分器更新
        event_indicator_update: this.scoresenData,
        //计分器保存
        event_indicator_save: this.scoresenData,
        //新增计分器
        event_indicator_add: this.scoresenData,
        //获取历史记录
        event_indicator_get_list: {
          class_id: this.$cookies.get("class_id"),
          page: localStorage.getItem("history_page"),
        },
        //返回列表
        event_indicator_return: {
          class_id: this.$cookies.get("class_id"),
        },
        //计分器详情
        event_indicator_get_detail: {
          class_id: this.$cookies.get("class_id"),
          id: localStorage.getItem("score_detail_id"),
        },
        event_timer_ready: this.timerSendData,
        //计时器 开始
        event_timer_start: this.timerSendData,
        //计时器 暂停
        event_timer_stop: {
          ...this.timerSendData,
          stop_time: parseInt(this.$cookies.get("timer_stop_time")), //暂停时的时间戳
        },
        event_timer_close: {
          ...this.timerSendData,
          stop_time: parseInt(this.$cookies.get("timer_stop_time")), //暂停时的时间戳
          type: this.$cookies.get("close_type"),
        },
        event_timer_reset: this.timerSendData,
        //倒计时开始
        event_down_timer_ready: this.downtimerSendData,
        event_down_timer_start: {
          ...this.downtimerSendData,
          time_long: parseInt(this.$cookies.get("time_long")),
          is_over_time:
            this.$cookies.get("is_over_time") == "false" ? false : true,
        },
        //倒计时暂停
        event_down_timer_stop: {
          ...this.downtimerSendData,
          time_long: parseInt(this.$cookies.get("time_long")),
          stop_time: parseInt(this.$cookies.get("timer_stop_time")), //暂停时的时间戳
          run_long: parseInt(this.$cookies.get("timer_small_time")), //暂停时的时间戳
        },
        event_down_timer_close: {
          ...this.downtimerSendData,
          time_long: parseInt(this.$cookies.get("time_long")),
          stop_time: parseInt(this.$cookies.get("timer_samll_time")), //暂停时的时间戳
        },
        event_down_timer_reset: this.downtimerSendData,
        event_down_timer_close_all: "", //倒计时-关闭所有事件
        // 投图更新
        event_teacher_pic_update: {
          pic_list: this.teacherPicImgList,
        },
        event_teacher_pic_close: {}, // 关闭投图
      };
      const obj = {
        event_name: type,
        token: this.$cookies.get("ws_token"),
        data: publicSendEvent[type],
      };
      if (this.websock.readyState != 1) {
        console.log(obj);
        console.log("网络服务正忙，请重新发送");
        return;
      }
      this.websocketSend(obj);
    },
    //判断jp是否隐藏互动页面
    judeJpPage(to) {
      if (this.$cookies.get("user_type") == 1) {
        if (
          to.name == "index" ||
          to.name == "teacher-course" ||
          to.name == "academic-analysis-topic" ||
          to.name == "academic-analysis-learning" ||
          to.name == "academic-analysis-problem"
        ) {
          if (this.jude_route && this.inser_show) {
            this.jude_route = true;
          }
        } else {
          this.jude_route = false;
        }
      }
    },
    //获取jp是否付费状态
    judeJpPayStatus() {
      try {
        if (localStorage.getItem("common_org_code") == "jp") {
          let data = {
            class_id: this.$cookies.get("class_id"),
          };
          jpGetUserInfo(data)
            .then((res) => {
              if (res.errCode == 0) {
                localStorage.setItem("jp_is_valid", res.data.is_valid);
                this.jude_jp_pay_status = res.data.is_valid;
                // this.judeJpPage(this.$route);
                //this.jude_show_page_inter(this.$route);
              } else {
                console.log(res.msg);
              }
            })
            .catch((err) => {
              throw new Error(err);
            });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //定时监听wbesock(5s)
    setInterFun() {
      clearInterval(this.ws_check_status);
      this.ws_check_status = setInterval(
        function () {
          this.judeJpPayStatus();
          console.log("----------------------------");
          console.log(this.org_jp_status);
          console.log(this.jude_jp_pay_status);
          console.log(this.websock.readyState);
          if (this.websock.readyState != 1) {
            if (!this.$cookies.get("ws_token")) {
              this.getWsTokenFun();
            } else {
              this.websocketInit();
              this.getTeacherLockScreenFun();
              this.input_status = false;
            }
          } else {
            this.input_status = true;
          }
        }.bind(this),
        5000
      );
    },
    //发送心跳
    sendHeartBeat() {
      if (window.location.pathname == "/login") {
        return;
      }
      this.sendPublic("heartbeat");
      clearTimeout(this.ws_heartBeat);
      this.ws_heartBeat = setTimeout(
        function () {
          this.sendHeartBeat();
        }.bind(this),
        3000
      );
    },
    //发送锁屏/解锁
    lockScreen() {
      this.lock_loading = true;
      if (this.websock.readyState == 1) {
        this.getMaiSuiSwitch();
      } else {
        if (!this.$cookies.get("ws_token")) {
          //this.$message("服务启动中,请稍等");
          return;
        }
        this.teacherLockScreenFun();
      }
    },
    //获取麦穗接口
    getMaiSuiSwitch() {
      getStuBookScreen()
        .then((res) => {
          if (res.errCode == 0) {
            this.$cookies.set("stu_book_lock_screen_status", res.data.status);
            this.sendPublic("event_server_lock_screen");
            if (this.lock_switch) {
              this.$flydata.flydataTrack(69);
            } else {
              this.$flydata.flydataTrack(68);
            }
          } else {
            console.log(res.msg);
            this.lock_loading = false;
          }
        })
        .catch((err) => {
          throw new Error(err);
          this.lock_loading = false;
        });
    },
    //发送点名
    callShow() {
      if (this.websock.readyState != 1) {
        //this.$message("点名服务暂停中...");
        return;
      }
      this.sendPublic("event_answer_ready");
    },
    //发送投屏
    throwShow() {
      if (this.websock.readyState != 1) {
        this.input_status = false;
        //this.$message("投屏服务暂停中...");
        return;
      }
      // this.throw_data = 1;
    },
    //打开计时器
    timerFun() {
      this.$flydata.flydataTrack(286);
      this.timer_data = 1;
      this.sendPublic("event_down_timer_ready");
    },
    //打开信号灯
    openLamp() {
      if (this.websock.readyState != 1) {
        //this.$message("信号灯服务暂停中...");
        return;
      }
      this.sendPublic("event_traffic_light_click");
    },
    //打开投票器
    openVoter() {
      if (this.websock.readyState != 1) {
        //this.$message("投票器服务暂停中...");
        return;
      }
      this.sendPublic("event_voter_click");
    },
    //学生打开投票器
    openVoterStudent() {
      if (this.websock.readyState != 1) {
        //this.$message("投票器服务暂停中...");
        return;
      }
      this.sendPublic("event_voter_click");
    },
    //打开计分器
    openScore() {
      if (this.websock.readyState != 1) {
        //this.$message("计分器服务暂停中...");
        return;
      }
      this.sendPublic("event_indicator_open");
    },
    //显示/隐藏工具栏
    show_interaction_type_func() {
      if (this.$cookies.get("inter_drag_status") == 0) {
        return;
      }
      this.show_interaction_type = !this.show_interaction_type;
      this.$flydata.flydataTrack(62);
    },
    //点击白板
    open_close_hand_write() {
      this.show_hand_write = !this.show_hand_write;
      this.show_interaction_type = false;
      if (this.show_hand_write) {
        this.$flydata.flydataTrack(71);
      }
    },
    //关闭手写板
    closeHandWriteFunc(val) {
      this.show_hand_write = val;
    },
    // 打开投图
    openPic() {
      this.$flydata.flydataTrack(285);
      this.pic_enabled = true;
      this.show_interaction_type = false;
    },
    onPicClose() {
      this.pic_enabled = false;
    },
    // 打开放大镜
    openMagnifier(type) {
      this.$flydata.flydataTrack(type === "magnifier" ? 262 : 267);

      if (this.$store.state.interaction.resource_preview_ppt) {
        this.$message.error("该工具暂不支持PPT类型资源。");
        return;
      }

      this.magnifier_enabled = true;
      this.magnifier_type = type;
      this.show_interaction_type = false;
    },
    // 关闭放大镜
    closeMagnifierFunc() {
      this.magnifier_enabled = false;
    },
    isElectron() {
      return false;
    },
    //ws初始化
    websocketInit() {
      if (!this.detailLackParam()) {
        console.log("缺少参数。。。");
        this.getUserInfo();
        return;
      } else {
        this.websockFun();
      }
    },
    /* websochet发送信息 */
    websocketSend(data) {
      this.websock.send(JSON.stringify(data));
    },
    /* websochet开启 */
    websocketonopen() {
      console.log("WebSocket连接成功");
      this.input_status = true;
      this.getToken();
    },
    /* websochet接收服务器返回的信息 */
    websocketMessage(e) {
      const parseData = JSON.parse(e.data);
      if (parseData.data.class_id) {
        if (parseData.data.class_id != this.$cookies.get("class_id")) {
          console.log("不同班级不进行反馈操作");
          return;
        }
      }
      switch (parseData.event_name) {
        case "event_client_lock_screen_notice": //锁屏/解锁通知
          this.lock_loading = false;
          if (this.$cookies.get("user_type") == this.identity.teacher) {
            this.lock_switch = parseData.data.lock_screen_status;
            return;
          }
          this.lock_data = parseData.data;
          break;
        case "event_client_token_notice": //token 错误通知
          // if (this.token_error_count > 10) {
          //   return;
          // }
          this.$cookies.remove("ws_token");
          this.getToken();
          this.token_error_count++;
          break;
        case "event_answer_ready": //服务端抢答准备事件
          parseData.data.radom_call_show = this.radom_call_show;
          console.log(parseData);
          this.$store.commit("answerreceive", parseData);
          break;
        case "event_answer_start": //服务端抢答开始事件
          parseData.data.radom_call_show = this.radom_call_show;
          this.$store.commit("answerreceive", parseData);
          break;
        case "event_answer_system_stop": //服务端抢答系统关闭事件
          this.$store.commit("answerreceive", parseData);
          break;
        case "event_answer_result": //客户端抢答结果事件
          this.$store.commit("answerreceive", parseData);
          break;
        case "event_random_answer_result": //客户端随机点名结果事件
          parseData.data.radom_call_show = this.radom_call_show;
          this.$store.commit("answerreceive", parseData);
          break;
        case "event_error_msg_notice": //客户端错误信息提示
          this.$message(parseData.data.msg);
          break;
        case "event_projection_screen": //客户端投屏事件
          console.log("客户端投屏事件");
          if (parseData.data.teacher_id != this.$cookies.get("user_id")) {
            console.log("投屏老师不相等");
            return;
          }
          // this.show_interaction_type = 1;
          this.throw_data = 1;
          this.throw_son_item = parseData;
          break;
        case "event_projection_screen_close": //客户端投屏关闭事件
          if (
            parseData.data.teacher_id &&
            parseData.data.teacher_id != this.$cookies.get("user_id")
          ) {
            console.log("关闭投屏老师不相等");
            return;
          }
          console.log("客户端投屏关闭事件");
          this.throw_data = 0;
          this.throw_son_item = parseData;
          break;
        case "event_traffic_light_result":
          //信号灯返回事件（所有）
          console.log(parseData);
          this.$store.commit("recelampevent", parseData);
          break;
        case "event_voter_latest_detail":
          //投票器返回事件（所有）
          console.log(parseData);
          this.$store.commit("recevoterevent", parseData);
          break;
        //event_indicator_latest_detail
        case "event_indicator_latest_detail":
          //投票器返回事件（所有）
          console.log("我是计分器返回的", parseData);
          this.$store.commit("recescoreevent", parseData);
          break;
        //event_indicator_get_list
        case "event_indicator_get_list":
          //投票器返回事件（所有）
          console.log("我是计分器返回的detail");
          this.$store.commit("recescoreevent", parseData);
          break;
        case "event_timer_ready": //准备计时器
          this.$store.commit("recetimersendevent", parseData);
          break;
        case "event_timer_start": //开始计时器
          if (parseData.data.status == 1) {
            this.timer_data = 1;
          }
          // console.log("开始计时器数据=================", parseData);
          this.$store.commit("recetimersendevent", parseData);
          break;
        case "event_timer_stop": //停止计时器
          this.$store.commit("recetimersendevent", parseData);
          // this.$store.commit('event_timer_stop',parseData);
          break;
        case "event_timer_continue": //继续计时器
          this.$store.commit("recetimersendevent", parseData);
          break;
        case "event_timer_close": //关闭计时器
          this.$store.commit("recetimersendevent", parseData);
          break;
        case "event_timer_reset": //重置计时器
          this.$store.commit("recetimersendevent", parseData);
          break;
        case "event_down_timer_ready": //准备倒计时
          this.$store.commit("recedowntimersendevent", parseData);
          break;
        case "event_down_timer_start": //开始计时器
          if (parseData.data.status == 1) {
            this.timer_data = 1;
          }
          // console.log("开始倒计时数据=================", parseData);
          this.$store.commit("recedowntimersendevent", parseData);
          break;
        case "event_down_timer_stop": //停止倒计时
          this.$store.commit("recedowntimersendevent", parseData);
          break;
        case "event_down_timer_continue": //继续倒计时
          this.$store.commit("recedowntimersendevent", parseData);
          break;
        case "event_down_timer_close": //关闭倒计时
          this.$store.commit("recedowntimersendevent", parseData);
          break;
        case "event_down_timer_close_all": //关闭倒计时
          this.timer_data = 0;
          this.$store.commit("recedowntimersendevent", parseData);
          break;
        case "event_down_timer_reset": //重置倒计时
          this.$store.commit("recedowntimersendevent", parseData);
          break;
        case "event_teacher_pic_start": //开始投图事件
          this.openTeacherPicWindow(parseData.data);
          break;
        case "event_teacher_pic_update": //更新投图列表事件
          this.openTeacherPicWindow(parseData.data);
          break;
        case "event_teacher_pic_stop": //停止投图事件
        case "event_teacher_pic_close": //关闭投图事件
          this.closeTeacherPicWindow();
          break;
        default:
          break;
      }
    },
    /* websochet错误 */
    websocketonerror(e) {
      //错误
      console.log("WebSocket连接发生错误");
    },
    /* websochet关闭时返回的信息 */
    websocketclose(e) {
      console.log(e);
    },
    //监听websock集合
    websockFun() {
      this.websock = new WebSocket(this.$cookies.get("http_ws_socket_url"));
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketMessage;
      this.websock.onclose = this.websocketclose;
    },
    //课堂互动拖拽事件
    // drag(e){
    //     if(e.target.nodeName=='SPAN'){
    //         return ;
    //     }
    //     var oDiv = e.path[1];
    //     var disX = e.clientX - oDiv.offsetLeft;
    //     var disY = e.clientY - oDiv.offsetTop;
    //     const orderHight = document.body.clientHeight-100;
    //     const orderWidth = document.body.clientWidth-100;
    //     document.onmousemove = function(e){
    //         e.preventDefault();
    //         var l = e.clientX - disX;
    //         var t = e.clientY - disY;
    //         if(l>0 && t>0 && l<orderWidth && t<orderHight){
    //             oDiv.style.left = l + "px"
    //             oDiv.style.top = t + "px"
    //         }
    //     }
    //     document.onmouseup = function(){
    //         document.onmousemove = null;
    //         document.onmouseup = null;
    //     }
    // },
    //获取屏幕高度和宽度
    gainBodyArea() {
      this.body_width = document.body.clientWidth - 30;
      this.body_height = document.body.clientHeight - 30;
      console.log(this.body_width);
      console.log(this.body_height);
    },
    //课堂互动拖拽事件
    drag(e) {
      let oDiv = e.path[1];
      let disX = e.clientX - oDiv.offsetLeft;
      let disY = e.clientY - oDiv.offsetTop;
      let cookieX = e.clientX;
      let cookieY = e.clientY;
      this.gainBodyArea();
      const _this = this;
      document.addEventListener(
        "touchmove",
        function () {
          e.preventDefault();
        },
        false
      );
      document.onmousemove = function (e) {
        e.preventDefault();
        let l = e.clientX - disX;
        let t = e.clientY - disY;
        if (
          l < -44 ||
          t < -44 ||
          l > _this.body_width ||
          t > _this.body_height
        ) {
          return;
        }
        oDiv.style.left = l + "px";
        oDiv.style.top = t + "px";
        // _this.$cookies.set("timer_small_left",l);
        // _this.$cookies.set("timer_small_top",t);
      };
      document.onmouseup = function (e) {
        if (e.clientX == cookieX && e.clientY == cookieY) {
          _this.$cookies.set("inter_drag_status", 1);
        } else {
          _this.$cookies.set("inter_drag_status", 0);
        }
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    //课堂互动拖拽事件(移动端)
    dragMobile(e) {
      let touch;
      let oDiv = e.path[1];
      if (e.touches) {
        //有可能对象在e上也有可能对象在e.touches[0]上
        touch = e.touches[0];
      } else {
        touch = e;
      }
      this.x = touch.clientX - oDiv.offsetLeft;
      this.y = touch.clientY - oDiv.offsetTop;
      this.gainBodyArea();
    },
    //课堂互动拖拽事件(移动端移动)
    dragMobileMove(e) {
      let touch;
      let oDiv = e.path[1];
      if (e.touches) {
        //有可能对象在e上也有可能对象在e.touches[0]上
        touch = e.touches[0];
      } else {
        touch = e;
      }
      //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
      let left = touch.clientX - this.x;
      let top = touch.clientY - this.y;
      if (
        left < -370 ||
        top < -50 ||
        left > this.body_width ||
        top > this.body_height
      ) {
        return;
      }
      //移动当前元素
      oDiv.style.left = left + "px";
      oDiv.style.top = top + "px";
      // this.$cookies.set("timer_small_left",left);
      // this.$cookies.set("timer_small_top",top);
      e.preventDefault(); //阻止页面的滑动默认事件
    },
    //拖拽开始
    down() {
      this.flag = true;
      let touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.cur.x = touch.clientX;
      this.cur.y = touch.clientY;
      this.dx = this.div2.offsetLeft;
      this.dy = this.div2.offsetTop;
      this.gainBodyArea();
    },
    down_copy(event) {
      event.preventDefault();
      this.flag = true;
      this.div2 = document.getElementById("interaction-wrap");
      this.body_width = document.body.clientWidth - 30;
      this.body_height = document.body.clientHeight - 30;
      // this.start_time = Date.parse(new Date());
      this.start_time = new Date().getTime();
      //判断是否是移动端
      if (event.touches) {
        // console.log(event.getPressure())
        this.pointer_obj.start_x = Math.ceil(event.touches[0].clientX);
        this.pointer_obj.start_y = Math.ceil(event.touches[0].clientY);
      } else {
        this.pointer_obj.start_x = Math.ceil(event.pageX);
        this.pointer_obj.start_y = Math.ceil(event.pageY);
      }
      this.move_obj.off_left = this.$refs.interactionBox.offsetLeft;
      this.move_obj.off_top = this.$refs.interactionBox.offsetTop;
    },
    //拖拽移动
    move() {
      if (this.flag) {
        let touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.cur.x;
        this.ny = touch.clientY - this.cur.y;
        this.x = this.dx + this.nx;
        this.y = this.dy + this.ny;
        if (
          this.x < -370 ||
          this.y < -50 ||
          this.x > this.body_width ||
          this.y > this.body_height
        ) {
          console.log("已超出边界");
          return;
        }
        this.div2.style.left = this.x + "px";
        this.div2.style.top = this.y + "px";
        //阻止页面的滑动默认事件
        document.addEventListener(
          "touchmove",
          function () {
            event.preventDefault();
          },
          false
        );
      }
    },
    move_copy(event) {
      event.preventDefault();
      // return ;
      if (this.flag) {
        if (event.touches) {
          this.pointer_obj.end_x = Math.ceil(event.touches[0].clientX);
          this.pointer_obj.end_y = Math.ceil(event.touches[0].clientY);
        } else {
          this.pointer_obj.end_x = Math.ceil(event.pageX);
          this.pointer_obj.end_y = Math.ceil(event.pageY);
        }

        this.x =
          this.pointer_obj.end_x -
          this.pointer_obj.start_x +
          this.move_obj.off_left;
        this.y =
          this.pointer_obj.end_y -
          this.pointer_obj.start_y +
          this.move_obj.off_top;
        this.div2.style.left = this.x + "px";
        this.div2.style.top = this.y + "px";
        if (this.x > this.body_width - 30) {
          this.x = this.body_width - 30;
        } else if (this.x < -50) {
          this.x = -50;
        }
        if (this.y < -50) {
          this.y = -50;
        } else if (this.y > this.body_height - 30) {
          this.y = this.body_height - 30;
        }
        this.div2.style.left = this.x + "px";
        this.div2.style.top = this.y + "px";
      }
    },
    //拖拽结束
    end() {
      this.flag = false;
      if (event.clientX == this.cur.x && event.clientY == this.cur.y) {
        this.$cookies.set("inter_drag_status", 1);
      } else {
        this.$cookies.set("inter_drag_status", 0);
      }
    },
    studentOpen() {
      this.show_interaction_type = !this.show_interaction_type;
    },
    whiteScreenOpen() {
      this.$store.commit("sendwhitescreen", 1);
    },
    end_copy(event) {
      event.preventDefault();
      this.flag = false;
      // this.end_time = Date.parse(new Date());
      this.end_time = new Date().getTime();
      if (this.end_time - this.start_time <= 200) {
        this.$cookies.set("inter_drag_status", 1);
        this.show_interaction_type_func();
        return;
      }
      if (
        event.clientX == this.pointer_obj.start_x &&
        event.clientY == this.pointer_obj.start_y
      ) {
        this.$cookies.set("inter_drag_status", 1);
      } else {
        this.$cookies.set("inter_drag_status", 0);
      }
    },
    end_leave(event) {
      event.preventDefault();
      this.flag = false;
    },
    //拖拽 renew
    test() {
      this.div2 = document.getElementById("interaction-wrap");
      const _this = this;
      _this.div2.addEventListener(
        "mousedown",
        function () {
          _this.down();
        },
        false
      );
      _this.div2.addEventListener(
        "touchstart",
        function () {
          _this.down();
        },
        false
      );
      _this.div2.addEventListener(
        "mousemove",
        function () {
          _this.move();
        },
        false
      );
      _this.div2.addEventListener(
        "touchmove",
        function () {
          _this.move();
        },
        false
      );
      document.body.addEventListener(
        "mouseup",
        function () {
          _this.end();
        },
        false
      );
      _this.div2.addEventListener(
        "touchend",
        function () {
          _this.end();
        },
        false
      );
    },
    //获取token和发送心跳
    getToken() {
      if (!this.$cookies.get("ws_token")) {
        this.getWsTokenFun();
      } else {
        this.sendPublic("event_user_connection");
        this.sendHeartBeat();
      }
    },
    //获取该班级的开关状态
    getInteractiveStatusFun(type) {
      // if (this.checkIsHxz()=== true) {
      //   return;
      // }
      let data = {
        class_id: this.$cookies.get("class_id"),
      };
      getInteractiveStatus(data)
        .then((res) => {
          if (res.errCode == 0) {
            console.log(res);
            if (res.data.im_interaction) {
              if (this.$cookies.get("user_type") == this.identity.teacher) {
                this.inser_show = true;
                this.inser_show = res.data.im_interaction;
                this.lock_show = res.data.im_interaction_screen;
                this.call_show = res.data.im_interaction_answer;

                this.lamp_show = res.data.im_interaction_signal_light;
                this.voter_show = res.data.im_interaction_vote;
                this.score_show = res.data.im_interaction_score;

                this.radom_call_show = res.data.im_interaction_random_answer;
                this.throw_show = res.data.im_interaction_projection_screen;

                this.spotlight_show = res.data.im_interaction_spotlight;
                this.pic_show = res.data.im_interaction_teacher_pic;
                this.timer_show = res.data.im_interaction_timer;

                let throw_show = res.data.im_interaction_projection_screen;
                if (this.isPc()) {
                  throw_show = 0;
                }

                let arr = [
                  this.lock_show,
                  this.call_show,
                  // this.radom_call_show,
                  throw_show,
                  this.lamp_show,
                  this.voter_show,
                  this.score_show,
                  this.pic_show,
                  this.spotlight_show,
                  this.timer_show,
                ];
                let count = 1;
                for (let value of arr) {
                  if (value == 1) {
                    count++;
                  }
                }
                // count += 3;

                this.barItemCount = count;
                this.setBarLayout();
              }
              if (this.websock) {
                if (this.websock.readyState != 1) {
                  this.websocketInit();
                } else {
                  if (type == 2) {
                    this.getToken();
                  }
                }
              } else {
                this.websocketInit();
              }
            } else {
              this.inser_show = false;
              this.$cookies.remove("class_id");
              this.$store.commit("cacheclass", {
                class_id: undefined,
                status: 0,
              });
            }
            if (this.$cookies.get("user_type") == this.identity.student) {
              this.voter_show = res.data.im_interaction_vote;
            }
          } else {
            this.is_show_student_white_screen = false;
            //this.$message(res.msg);
          }
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    setBarLayout() {
      const $interactionBar = $(".interaction-type");
      const widthPerItem = 90;
      const count = this.barItemCount;
      let barWidth = widthPerItem * count;

      if (barWidth + 100 > window.innerWidth) {
        const nums = count % 2 === 0 ? count : count + 1;
        barWidth = (nums * widthPerItem) / 2;

        this.is_two_rows = true;
      } else {
        this.is_two_rows = false;
      }

      $interactionBar.width(barWidth);
    },
    //获取websocket token
    getWsTokenFun(type) {
      getWsToken()
        .then((res) => {
          if (res.errCode == 0) {
            this.$cookies.set("ws_token", res.data.token);
            // this.token_error_count = 0;
            if (type == "http") {
              return;
            }
            this.sendPublic("event_user_connection");
            this.sendHeartBeat();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    //退出登录
    logout() {
      logoutApi()
        .then((res) => {
          if (res.errCode == 0) {
            this.logout_path();
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    //获取用户信息
    getUserInfo() {
      if (
        window.location.pathname == "/login" ||
        window.location.pathname == "/jp-login" ||
        window.location.pathname == "/register" ||
        window.location.pathname == "/forget-password" ||
        window.location.pathname == "/ground" ||
        window.location.pathname.indexOf("public-login") > -1
      ) {
        clearInterval(this.ws_check_status);
        return;
      }
      getWsUserInfo()
        .then((res) => {
          if (res.errCode == 0) {
            if (!res.data.class_id) {
              this.logout();
              return;
            }
            this.$cookies.set("class_id", res.data.class_id);
            this.$cookies.set("user_type", res.data.user_type);
            this.$cookies.set("user_id", res.data.user_id);
            this.$cookies.set("ws_token", res.data.token);
            this.$cookies.set("http_ws_host", res.data.host_url);
            this.$cookies.set("http_ws_socket_url", res.data.socket_url);
            if (this.websock.readyState != 1) {
              this.websockFun();
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    //http方式点击锁屏或者解锁状态
    teacherLockScreenFun() {
      let data = {
        token: this.$cookies.get("ws_token"),
        class_id: this.$cookies.get("class_id"),
        lock_screen_status: this.lock_switch ? 0 : 1,
        request_cross_domain: window.location.host,
      };
      const host = this.$cookies.get("http_ws_host");
      const _this = this;
      _this.lock_loading = true;
      $.ajax({
        type: "GET",
        url: host + "/api/akdm-service/teacher-lock-screen",
        data: data,
        dataType: "json",
        success: function (res) {
          _this.lock_loading = false;
          if (res.errCode == 0) {
            if (_this.$cookies.get("user_type") == _this.identity.teacher) {
              _this.lock_switch = res.data.lock_screen_status;
              if (_this.lock_switch) {
                _this.$flydata.flydataTrack(68);
              } else {
                _this.$flydata.flydataTrack(69);
              }
              return;
            }
            _this.lock_data = res.data;
          } else {
            _this.$message(res.msg);
          }
        },
        error: function (xhr, type) {
          _this.lock_loading = false;
          console.log(xhr);
        },
      });
      // return;
      // teacherLockScreen(data,host)
      //   .then(res => {
      //     if(res.errCode == 0){
      //         console.log(res);
      //     }else{
      //       this.$message(res.msg);
      //     }
      // })
      // .catch(err => {
      //   throw new Error(err);
      // });
    },
    //http方式点击锁屏或者解锁状态
    getTeacherLockScreenFun() {
      let data = {
        token: this.$cookies.get("ws_token"),
        class_id: this.$cookies.get("class_id"),
        request_cross_domain: window.location.host,
      };
      const _this = this;
      const host = this.$cookies.get("http_ws_host");
      $.ajax({
        type: "GET",
        url: host + "/api/akdm-service/get-lock-screen-status",
        data: data,
        dataType: "json",
        success: function (res) {
          if (res.errCode == 0) {
            if (_this.$cookies.get("user_type") == _this.identity.teacher) {
              _this.lock_switch = res.data.lock_screen_status;
              return;
            }
            _this.lock_data = res.data;
          } else {
            //  _this.$message(res.msg);
            console.log(res.msg);
          }
        },
        error: function (xhr, type) {
          console.log(xhr);
        },
      });
      // return;
      // getTeacherLockScreen(data,host)
      //   .then(res => {
      //     if(res.errCode == 0){
      //         // console.log(res);
      //     }else{
      //       this.$message(res.msg);
      //     }
      // })
      // .catch(err => {
      //   throw new Error(err);
      // });
    },
    //判断是否显示课堂互动(页面)
    jude_show_page_inter(to) {
      if (this.$cookies.get("user_type") == 1) {
        if (
          to.name == "index" ||
          to.name == "teacher-course" ||
          to.name == "academic-analysis-topic" ||
          to.name == "academic-analysis-learning" ||
          to.name == "academic-analysis-problem"
        ) {
          this.jude_route = true;
        } else {
          this.jude_route = false;
          if (this.$route.name == "personal-center") {
            this.$store.commit("cacheclass", {
              class_id: undefined,
              status: 0,
            });
          }
        }
      } else {
        if (to.name == "login") {
          this.jude_route = false;
          return;
        }
        this.jude_route = true;
        if (to.name != "student-index") {
          this.is_show_student_white_screen = false;
        } else {
          this.is_show_student_white_screen = true;
        }
      }
    },
    //互动初始化
    init(type) {
      if (this.checkIsHxz() === true) {
        return;
      }
      if (!this.$cookies.get("class_id")) {
        if (this.websock) {
          this.websock.close();
        }
        this.inser_show = false;
        clearInterval(this.ws_check_status);
        return;
      }
      if (this.$cookies.get("user_type") == this.identity.student) {
        $(".interaction-type").width("max-content");
        this.show_interaction_type = false;
        this.inser_show = false;
      }
      this.judeJpPayStatus();
      this.getInteractiveStatusFun(type);
      this.setInterFun();
      this.jude_show_page_inter(this.$route);
    },
    isValidTeacherPic(data) {
      return (
        this.$cookies.get("user_id") == data.user_id &&
        this.$cookies.get("user_type") == data.user_type_id &&
        data.pic_version != this.teacherPicVersion
      );
    },
    openTeacherPicWindow(data) {
      if (this.isValidTeacherPic(data)) {
        this.isShowTeacherPic = true;
        this.teacherPicVersion = data.pic_version;
        this.teacherPicImgList = data.pic_list;
      }
    },
    updateTeacherPicList(data) {
      if (this.isValidTeacherPic(data)) {
        this.teacherPicVersion = data.pic_version;
        this.teacherPicImgList = data.pic_list;
      }
    },
    closeTeacherPicWindow() {
      this.isShowTeacherPic = false;
      this.teacherPicImgList = [];
    },
    onTeacherPicClose() {
      this.isShowTeacherPic = false;
      this.teacherPicImgList = [];
      this.sendPublic("event_teacher_pic_close");
    },
    onTeacherPicChange(imgList) {
      this.teacherPicImgList = imgList;
      this.sendPublic("event_teacher_pic_update");
    },
  },
  created() {
    if (this.$cookies.get("user_type") == this.identity.teacher) {
      window.addEventListener("resize", this.setBarLayout, false);

      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("resize", this.setBarLayout);
      });
    }
  },
  watch: {
    $route(to, from) {
      this.jude_show_page_inter(to);
      this.magnifier_enabled = false;
    },
    listenstage(val) {
      this.init(2); //watch类型
    },
    answersen(val) {
      let index = val.lastIndexOf("&");
      val = val.substring(index + 1, val.length);
      this.sendPublic(val);
    },
    lampsen(val) {
      let index = val.lastIndexOf("&");
      val = val.substring(index + 1, val.length);
      this.sendPublic(val);
    },
    votersen(val) {
      let index = val.lastIndexOf("&");
      val = val.substring(index + 1, val.length);
      this.sendPublic(val);
    },
    scoresen(val) {
      let index = val.lastIndexOf("&");
      val = val.substring(index + 1, val.length);
      this.sendPublic(val);
    },
    timerSend(val) {
      let index = val.lastIndexOf("&");
      val = val.substring(index + 1, val.length);
      this.sendPublic(val);
    },
    downtimerSend(val) {
      let index = val.lastIndexOf("&");
      val = val.substring(index + 1, val.length);
      this.sendPublic(val);
    },
  },
  mounted() {
    this.init(1); //mounted类型
    window.onorientationchange = function () {
      this.div2 = document.getElementById("interaction-wrap");
      this.x = 0;
      this.y = 0;
      this.div2.style.right = "0.5rem";
      this.div2.style.bottom = "0.5rem";
      this.div2.style.left = "";
      this.div2.style.top = "";
    };
  },
  destroyed() {
    clearInterval(this.ws_check_status);
    window.onorientationchange = null;
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
